import styled from "styled-components";

export const EngineeringNav = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 1%;
  padding-top: 1vh;
  cursor: auto;
`;

export const EngineeringRow = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: start;
    text-align: start;
    z-index: 1;
`;

export const EngineeringTitle = styled.div`
    color: #0071CE;
    font-size: 0.9vw;
    margin-bottom: 3%;
    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }
`;

export const EngineeringBody = styled.div`
    color: #565656;
    font-size: 0.9vw;
    font-style: normal;
    font-weight: 400;
    cursor: pointer;
`;